<template>
    <div class="wrapper" v-if="hasListings">
        <div class="row no-gutters no-row-padding">
            <div class="col-12 h-100 px-3">
                <h4>{{ $t('components.promotedListings.title') }}</h4>
                <Spinner v-if="loading"></Spinner>
                <CardCarousel>
                    <div 
                        class="col-lg-3 col-md-4 col-sm-6 col-12 no-row-padding mx-auto" 
                        v-for="lst in listings"
                        :key="lst.title">
                        <div class="listingCard">
                            <div class="cardWrapper">
                                <div class="card" @click="visitUrl(lst.url)">
                                    <!-- <ImageCarousel :images="computeSmallImages(lst)" style="min-height: 150px; height: 150px"></ImageCarousel> -->
                                    <div class="card-img-top" style="height: 180px;width: 100%">
                                        <img :src="computeSmallImages(lst).url" alt="Card image cap" style='height: 100%; width: 100%; object-fit: cover; border-radius: 5px;'>
                                        <div class="ad-container">
                                            <div class="ad-text">
                                                {{ $t('components.promotedListings.ad') }}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="card-body">
                                        <h5 class="card-title">{{ lst.title }}</h5>
                                        <!-- ICONS -->
                                        <p class="card-text">{{ lst.description }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </CardCarousel>
            </div>
        </div>
        </div>
</template>

<script>
import ImageCard from "@/components/level1/ImageCard";
import CardCarousel from "@/components/common/CardCarousel";
import ImageCarousel from "@/components/common/ImageCarousel";
import Spinner from "@/components/common/Spinner";
export default {
    name: "PromotedListings",
    components: {
        ImageCard,
        CardCarousel,
        ImageCarousel,
        Spinner
    },
    mounted() {
        this.getPromotedListings();
    },
    computed: {
        hasListings: function() {
            if (this.listings === undefined) {
                return false;
            }

            return this.listings.length > 0;
        }
    },
    methods: {
        getPromotedListings: function() {
            this.loading = true;
            this.$http.get(`/promoted`).then(res => {
                this.listings = res.data;
                console.log(this.listings)
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                this.loading = false;
            })
        },
        computeSmallImages(listing) {
            
            if (this.isUndefined(listing) || this.isUndefined(listing.image) || listing.image.length === 0) {
                return [{
                    id: 1,
                    url: this.resolveImage(undefined, undefined)
                }];
            }

                return {
                    id: listing.image.id,
                    url: this.resolveImage(listing.image, 'small')
            };
        },
        visitUrl: function(url) {
            window.open(url, '_blank');
        }
    },
    data() {
        return {
            listings: undefined,
            loading: false
        }
    }
}
</script>


<style scoped lang="scss">
    $border-radius: 5px;
    .wrapper {
        background-color: white;
        // padding: 16px;
        border-radius: $border-radius;
        max-height: 100%;
        width: 100%;
        margin-top: 8px;
    }

    .cardWrapper {
        min-width: fit-content;
        padding-left: 10px;
        padding-right: 10px;
    }

    .card {
        border-radius: $border-radius;
        cursor: pointer;
        min-width: fit-content;
        border: 0;
    }

    .card-title {
        font-size: 12px;
        margin-bottom: 0px;
        font-family: "Noto Serif SC", serif;
        color: $text-color;
    }

    .card-text {
        font-size: 12px;
        line-height: 14px;
        font-family: "Noto Serif SC", serif;
    }

    .card-body {
        padding: 10px;
    }

    h4 {
        margin: 5px;
        margin-bottom: 15px;
        margin-top: 15px;
        font-family: "Museo Sans", serif;
        color: $text-color;
    }

    .ad-container {
        position: relative; 
        bottom: 32px; 
        right: 0; 
        width: 100%;  
    }

    .ad-text {
        font-family: "Museo Sans", serif;
        display: inline-block; 
        text-transform: uppercase; 
        background-color: $soft-red; 
        margin: 8px; 
        padding: 2px 4px;
        font-size: 12px;
        line-height: 11px;
        border-radius: 2px;
        color: white;
    }

    
</style>